import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";

import { AuthService } from "../service/auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

  //   // this.authService.logintracker({"loginTrackId":localStorage.getItem('loginTrackId'),"btn_name":"CHECKLOGOUT"}).subscribe((res) => {
  //   //   console.log("checklogout",res);
  //   //   if(res[0].logoutStatus == 'Y'){
  //   //     this.authService.logout().subscribe((res) => {
  //   //       if (!res.success) {
  //   //         this.router.navigate(["/authentication/signin"]);
  //   //       }
  //   //     });
  //   //   }
  //   // });

  //   if (this.authService.currentUserValue) {
  //     // const userRole = this.authService.currentUserValue.role;
  //     // if (route.data.role && route.data.role.indexOf(userRole) === -1) {
  //     //   this.router.navigate(['/authentication/signin']);
  //     //   return false;
  //     // }
  //     // return true;
  //     if(this.authService.currentUserValue.userId == ''){
  //       this.router.navigate(['/authentication/signin']);
  //       return false;
  //     }
  //     return true;
  //   }

  //   this.router.navigate(['/authentication/signin']);
  //   return false;
  // }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    // First check current user from AuthService
    const currentUser = this.authService.currentUserValue;

    if (currentUser && currentUser.userId) {
      return true;
    }

    // Fallback for another tab (BroadcastChannel case)
    const userId = localStorage.getItem("userId");

    if (
      userId &&
      userId !== "" &&
      userId !== "undefined" &&
      userId !== "null"
    ) {
      return true;
    }

    this.router.navigate(["/authentication/signin"]);
    return false;
  }
}
